import { render, staticRenderFns } from "./StartseiteZimmerReservation.vue?vue&type=template&id=75a5e4b1"
import script from "./StartseiteZimmerReservation.vue?vue&type=script&lang=js"
export * from "./StartseiteZimmerReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports